import { render, staticRenderFns } from "./DropdownProjects.vue?vue&type=template&id=7316c6cf&scoped=true&"
import script from "./DropdownProjects.vue?vue&type=script&lang=js&"
export * from "./DropdownProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7316c6cf",
  null
  
)

export default component.exports